import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImagesSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"images-sparkle, photos, pictures, shot, generate"} maskId="square-filled-radius-0-stroke-1-IconImagesSparkle"><path d="M18.4 2H17.6L16.6 4.6L14 5.6V6.4L16.6 7.4L17.6 10H18.4L19.4 7.4L22 6.4V5.6L19.4 4.6L18.4 2Z" fill="currentColor"/><path d="M12 4H4V15.293L8 11.293L12 15.293L14 13.293L20 19.293V12H21V21H3V3H12V4Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconImagesSparkle;
